// AnimatedContainer.js

import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import './styles.css';

function AnimatedContainer({ children, animationDuration }) {
  const containerRef = useRef();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const topPosition = containerRef.current.getBoundingClientRect().top;
      const isVisible = topPosition < window.innerHeight * 0.75;

      if (isVisible) {
        setIsVisible(true);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const animationStyle = {
    animation: isVisible ? `fadeIn ${animationDuration} ease-in-out forwards` : 'none',
  };

  return (
    <div className="animated-container" ref={containerRef} style={animationStyle}>
      {children}
    </div>
  );
}

AnimatedContainer.propTypes = {
  children: PropTypes.node.isRequired,
  animationDuration: PropTypes.string.isRequired,
};

export default AnimatedContainer;
